import { UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';

export enum QueryKey {
	Bonuses = 'bonuses',
	BonusesInfinite = 'bonuses-infinite',
	Company = 'company',
	CompanyProfile = '$global-company-profile',
	GIFs = 'gifs',
	GlobalSearch = 'global-search',
	Hashtags = 'hashtags',
	JWT = 'jwt',
	Leaderboard = 'leaderboard',
	Recipients = 'recipients',
	Rewards = 'rewards',
	UserProfile = '$global-user-profile',
	Users = 'users',
}

export type MutationOptions<T = unknown, U = unknown> = Omit<UseMutationOptions<U, unknown, T>, 'mutationFn'>;

export type QueryOptions<T = unknown, E = unknown, D = T> = Omit<UseQueryOptions<T, E, D>, 'queryFn' | 'queryKey'>;

export enum ResourcePath {
	Bonus = 'bonuses/{id}',
	Bonuses = 'bonuses',
	BonusImages = 'bonus_images',
	BonusReports = 'bonus_reports',
	BonuslyUser = 'user',
	Company = 'companies/show',
	GIFs = 'gifs',
	Hashtags = 'hashtags',
	JWT = 'jwt',
	Reaction = 'reactions/{id}',
	Reactions = 'reactions',
	Recipients = 'recipients',
	Rewards = 'rewards',
	Users = 'users',
	UsersAutocomplete = 'users/autocomplete',
	Leaderboard = 'leaderboards',
	User = 'users/show',
	UsersInvite = 'invitations',
}
